export default function NavigatableIntegrationFooter({ children }) {
  return (
    <div className="NavigatableIntegrationWidgetCard-Footer">{children}</div>
  )
}
